import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/core/models/user';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { MasterHelper } from './../../../core/utilities/master-helper';
import { ItemInfoDto } from 'src/app/core/models/rulebook/item.info-dto';
import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { HelpModel } from 'src/app/core/models/user-management/help-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { CommonService } from './../../../core/services/common/common.service';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { UserService } from 'src/app/core/services/user';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { RegulationFilterModel } from 'src/app/core/models/regulation';
import { O } from '@angular/cdk/keycodes';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';
import { RulebookFilterModel } from 'src/app/core/models/rulebook/rulebook-filters-model';
import { ThemeModel } from 'src/app/core/models/user-management/theme-model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ThemeGetModel } from 'src/app/core/models/user-management/get-theme-details-model';
import { UserInfoForJurisdictinUpdate } from 'src/app/core/models/user/user-info-for-jurisdictin-update';
import { GDPRService } from 'src/app/core/services/rulebook';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  @ViewChild('navbar') collapsibleNav: any;
  isCollapsed: boolean;
  isLoggedIn: Observable<boolean> = new Observable<boolean>();
  loggedInUser: UserProfile;
  windowWidth = 1000;
  libraryMenu: Array<MenuItemModel>;
  helpData: HelpModel;

  isRegCollapsed = false;
  isWFMCollapsed = false;
  isLibCollapsed = false;
  isLoadingMenu = false;
  currentUrl = '';
  userJurisdiction!: Array<ItemIdModel>;
  divisionId!: number;
  filterPersistenceKey = 'rulebookFilters';
  regulationFilter!: RegulationFilterModel;
  divisionName!: string;
  rulebookFiltersData: RulebookFilterModel;
  userRoleId: number = 0;
  selectedDivisionName: string = '';
  // logoAddress:string = '';
  safeImageUrl!: SafeUrl;
  themeDetails!: ThemeGetModel;
  // bannerAddress:string = '';
  imageSrc: string | null = null;
  bannerSrc: string | null = null;
  templateNo:number =0;

  constructor(
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private sessionService: SessionService,
    public commonService: CommonService,
    private userManagement: UserManagementService,
    private router: Router,
    private _userService: UserService,
    private generalService: GeneralDataService,
    private sanitizer: DomSanitizer,
    private gdprService: GDPRService,
  ) {
    this.rulebookFiltersData = new RulebookFilterModel();
    this.libraryMenu = [];
    this.loggedInUser = new UserProfile();
    this.windowWidth = window.innerWidth as number;
    if (this.windowWidth < 992) {
      this.isCollapsed = true;
    } else {
      this.isCollapsed = false;
    }
    const urlArr = window.location.href.split('library');
    this.currentUrl = urlArr.length > 1 ? '/library' + window.location.href.split('library')[1] : '';
    this.helpData = new HelpModel();
    const saveCollapsed = MasterHelper.fetchFromBrowser('_cmi' as string);
    if (saveCollapsed) {
      this.isCollapsed = (saveCollapsed === 'true' || saveCollapsed === 'True') ? true : false;
      this.commonService.isSidebarShow = !this.isCollapsed;
    }
  }

  @HostListener('window:resize', ['$event'])

  onResize(event: any): void {
    this.windowWidth = event.target.innerWidth as number;
    if (this.windowWidth < 992) {
      this.isCollapsed = true;
    } else {
      this.isCollapsed = false;
    }
  }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isLoggedIn;
    this.fetchUserProfile();
    this.fetchUserTheme();
    
    this.fetchHelpData();
    this.generalService.changeSATemplate$.subscribe((changedTemplateNo:number) => {
      if(changedTemplateNo != this.templateNo){
        this.templateNo=changedTemplateNo;
        this.fetchMenuItems();
      }
    });
  }
  fetchUserTheme(): void {
    this.imageSrc = localStorage.getItem('imageSrc');
    this.bannerSrc = localStorage.getItem('bannerSrc');
    if (this.imageSrc == null && this.bannerSrc == null) {
      this.userManagement.getThemeDetails().subscribe((res: ThemeGetModel) => {
        this.themeDetails = res;
        this.imageSrc = `data:image/png;base64,${this.themeDetails.image}`;
        this.bannerSrc = `data:image/jpg;base64,${this.themeDetails.banner}`;
      });
    }
  }
  getSafeImageUrl(imagePath: string): SafeUrl {
    const sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl(imagePath);
    return sanitizedUrl;
  }

  async fetchUserProfile():Promise<void> {
    this.isLoadingMenu = true;
    this.sessionService.getLoginUserInfo().subscribe(async (user: UserProfile) => {
      this.userRoleId = user.roleId;
      this.loggedInUser = user;
      this._userService.userInfo = user;
      this._userService.isUserInfoFistTime = false;
      const templateNo: number = await this.gdprService
      .getSelfAssessmentTemplate(this.loggedInUser.lastUsedJurisdictionId)
      .toPromise();
      this.templateNo = templateNo;
      this.fetchMenuItems();
      this.fetchUserJurisdiction();
    });
  }

  forceSignOff(): void {
    let userInfo= new UserInfoForJurisdictinUpdate();
    userInfo.lastUsedJurisdictionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    userInfo.id=this.loggedInUser.userId;
    this.userManagement.updateUserProfileJurisdictions(userInfo).subscribe(() => {

    });
    this.sessionService.logOut();
    window.location.href = '/Fallback/ForceSO';
  }

  logoutAudit(): void {
    const itemInfoDto = new ItemInfoDto();
    itemInfoDto.screenUrl = this.router.url;
    this.sessionService.logOutAudit(itemInfoDto).subscribe(() => {
    });
  }

  toggleClass(): void {
    this.windowWidth = window.innerWidth as number;
    if (this.windowWidth < 992) {
      this.isCollapsed = true;
    }
    const hasClass = this.collapsibleNav.nativeElement.classList.contains('show');

    if (hasClass) {
      this.collapsibleNav.nativeElement.classList.remove('show');
    } else {
      this.collapsibleNav.nativeElement.classList.add('show');
    }
    this.currentUrl = '';
  }

  showHideSidebar(): void {
    this.isCollapsed = !this.isCollapsed;
    this.commonService.isSidebarShow = !this.isCollapsed;
    MasterHelper.saveOnBrowser('_cmi', this.isCollapsed.toString());
  }
 
  async fetchMenuItems(): Promise<void> {
    this.analyticsService.getLibraryMenu().subscribe((data: MenuItemModel[]) => {
      this.libraryMenu = data;
      if(this.templateNo==3){
        this.libraryMenu =this.libraryMenu.filter(ob=>ob.screenName !=="Enhancements" && ob.screenName !=="Gaps");
      }
      this.isLoadingMenu = false;
      this._userService.menueItems = data;
    });
  }

  collapseMenu(collapse: boolean): void {
    collapse = !collapse;
  }

  fetchHelpData(): void {
    this.userManagement.getHelpData().subscribe((result: HelpModel) => {
      this.helpData = result;
    });
  }

  async fetchUserJurisdiction(): Promise<void> {
    if (this._userService.userJurisdiction.length > 0) {
      this.userJurisdiction = this._userService.userJurisdiction;
      this.setDivision();
    }
    else {
      let result: ItemIdModel[]= await this.userManagement.getUserJurisdictions().toPromise();
       this.userJurisdiction = result;
       this._userService.userJurisdiction = result;
       this.setDivision();
    }
  }

  setDivision(): void {
    const persistFilter = JSON.parse(this.fetchFromBrowser(this.filterPersistenceKey) as string) as RegulationFilterModel;
    this.regulationFilter = persistFilter;
    const localJurisdiction = this.loggedInUser.lastUsedJurisdictionId;
    let setdivisionId = 0;
    if(localJurisdiction && localJurisdiction != 0){
      setdivisionId=localJurisdiction;
    }
    else{
      setdivisionId = this._userService.userInfo.lastUsedJurisdictionId;
    }
    //const setdivisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    // if (persistFilter && persistFilter.divisionId && persistFilter.divisionId != 0) {
    //   this.divisionId = persistFilter.divisionId;
    // }
    if (setdivisionId && setdivisionId != 0) {
      this.divisionId = setdivisionId;
      // this.userJurisdiction.forEach(element => {
      //   if (element.id == this.divisionId) {
      //     this.selectedDivisionName = element.name;
      //   }
      // });
      const selectedDivision = this.userJurisdiction.find(jrds => jrds.id === this.divisionId);
      if (selectedDivision) {
       this.selectedDivisionName = selectedDivision.name;
      } else {
       this.selectedDivisionName = ''; // Reset if division is not found
      }
      localStorage.setItem('selectedDivisionName', this.selectedDivisionName);
    }
    else {
      if (this.userJurisdiction && this.userJurisdiction.length > 0) {
        this.divisionId = this.userJurisdiction[0].id;
        this.selectedDivisionName = this.userJurisdiction[0].name;
        localStorage.setItem('selectedDivisionName', this.selectedDivisionName);
      } else {
        this.divisionId = 0;
        this.selectedDivisionName = this.userJurisdiction[0].name;
        localStorage.setItem('selectedDivisionName', this.selectedDivisionName);
      }
    }
    if (this.divisionId && this.divisionId > 0) {
      let FilteredRow = this.userJurisdiction.filter(ob => ob.id == this.divisionId);

      if (FilteredRow.length > 0) {
        this.divisionName = FilteredRow[0].name;
      }
      else if (this.userJurisdiction && this.userJurisdiction.length > 0) {
        this.divisionId = this.userJurisdiction[0].id;
        this.divisionName = this.userJurisdiction[0].name;
        this.selectedDivisionName = this.divisionName;
        localStorage.setItem('selectedDivisionName', this.selectedDivisionName);
      }
    }
    if (this.regulationFilter) {
      this.regulationFilter.divisionId = this.divisionId;
    }
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
    localStorage.setItem('selectedDivision', this.divisionId.toString());
    localStorage.setItem('selectedDivisionName', this.selectedDivisionName);
  }
  async changeDivision(divisionId:any): Promise<void> {
    localStorage.setItem('selectedDivision', this.divisionId.toString());
    let userInfo= new UserInfoForJurisdictinUpdate();
    userInfo.lastUsedJurisdictionId = this.divisionId;
    userInfo.id=this.loggedInUser.userId;
    this.userManagement.updateUserProfileJurisdictions(userInfo).subscribe(() => {
    });
    const selectedDivision = this.userJurisdiction.find(jrds => jrds.id === this.divisionId);
    if (selectedDivision) {
     this.selectedDivisionName = selectedDivision.name;
    } else {
     this.selectedDivisionName = ''; // Reset if division is not found
    }
    localStorage.setItem('selectedDivisionName', this.selectedDivisionName);
    const templateNo: number = await this.gdprService
      .getSelfAssessmentTemplate(userInfo.lastUsedJurisdictionId)
      .toPromise();
    if(templateNo != this.templateNo){
      this.templateNo=templateNo;
      this.fetchMenuItems();
    }
    this.generalService.setDivisionSelected(this.divisionId);
  }
  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }
  redirectLink(link: string) {
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.rulebookFiltersData));
    const decodedLink = decodeURIComponent(link);
    this.currentUrl = decodedLink;
    this.router.navigate([decodedLink]);
  }
  decodeUrl(url: string): string {
    return decodeURIComponent(url);
  }
}
